import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import TopBar from "@/components/TopBar";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Users, ClipboardCheck, Receipt, FileText, Bell, Tag } from "lucide-react";

export default function AdminLayout() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const isReportsOnly = user?.role === "report_viewer";

  return (
    <div className="shell">
      <TopBar />
      <div className="admin-layout">
        <aside className="sidebar" data-testid="admin-sidebar">
          {!isReportsOnly && (
            <>
              <NavLink to="/admin" end className={({isActive}) => `side-link ${isActive ? "active" : ""}`} data-testid="nav-dashboard"><LayoutDashboard size={16}/> {t("admin.dashboard")}</NavLink>
              <NavLink to="/admin/employees" className={({isActive}) => `side-link ${isActive ? "active" : ""}`} data-testid="nav-employees"><Users size={16}/> {t("admin.employees")}</NavLink>
              <NavLink to="/admin/attendance" className={({isActive}) => `side-link ${isActive ? "active" : ""}`} data-testid="nav-attendance"><ClipboardCheck size={16}/> {t("admin.attendance")}</NavLink>
              <NavLink to="/admin/expenses" className={({isActive}) => `side-link ${isActive ? "active" : ""}`} data-testid="nav-expenses"><Receipt size={16}/> {t("admin.expenses")}</NavLink>
              <NavLink to="/admin/notifications" className={({isActive}) => `side-link ${isActive ? "active" : ""}`} data-testid="nav-notifications"><Bell size={16}/> {t("admin.notifications")}</NavLink>
              <NavLink to="/admin/expense-categories" className={({isActive}) => `side-link ${isActive ? "active" : ""}`} data-testid="nav-expense-categories"><Tag size={16}/> {t("admin.expenseCategories")}</NavLink>
            </>
          )}
          <NavLink
            to="/admin/reports"
            end={isReportsOnly}
            className={({isActive}) => `side-link ${isActive ? "active" : ""}`}
            data-testid="nav-reports"
          >
            <FileText size={16}/> {t("admin.reports")}
          </NavLink>
        </aside>
        <main><Outlet /></main>
      </div>
    </div>
  );
}
